export default "__VITE_ASSET__9c0b0880__"